import { defineLegacyDefaultTheme } from './defineLegacyDefaultTheme';

/** A deep ember charcoal with a soft amber accent. */
export const emberTheme = defineLegacyDefaultTheme({
  id: 'Ember',
  tokens: {
    a0: { l: 0.75, c: 0.15, h: 55 },
    a1: { l: 0.75, c: 0.15, h: 95 },
    a2: { l: 0.75, c: 0.15, h: 135 },
    a3: { l: 0.75, c: 0.15, h: 175 },
    a4: { l: 0.75, c: 0.15, h: 215 },
    b0: { l: 0.16, c: 0.01, h: 55 },
    b1: { l: 0.2, c: 0.01, h: 55 },
    b2: { l: 0.24, c: 0.012, h: 55 },
    b3: { l: 0.27, c: 0.012, h: 55 },
    b4: { l: 0.31, c: 0.014, h: 55 },
    c0: { l: 0.95, c: 0.008, h: 55 },
    c1: { l: 0.83, c: 0.008, h: 55 },
    c2: { l: 0.73, c: 0.008, h: 55 },
    c3: { l: 0.63, c: 0.008, h: 55 },
    c4: { l: 0.55, c: 0.008, h: 55 },
  },
});
